import { fromJS } from 'immutable';

import { TaxonomyTheme } from '../types/uncinc_profile/taxonomy';

export default function createParentChildArray(objects: TaxonomyTheme[]) {
  // Helper function to find an object by its ID
  const findById = (ob: TaxonomyTheme[], id: number) => ob.find((o) => o.tid[0].value === id);

  // Create a map to store parent objects with their children objects
  const parentChildMap = new Map();

  // Process each object to populate the map
  objects.forEach((obj) => {
    // Get parent ID
    const parentId = obj?.parent[0]?.target_id;

    // If the object has a parent ID
    if (parentId) {
      // Find or create the parent entry
      let parentEntry = parentChildMap.get(parentId);
      if (!parentEntry) {
        const parentObj = findById(objects, parentId);
        parentEntry = parentObj ? { parent: parentObj, children: [] } : null;
        if (parentEntry) {
          parentChildMap.set(parentId, parentEntry);
        }
      }
      // If we have a parent entry, add the current object as a child
      if (parentEntry) {
        parentEntry.children.push(obj);
      }
    } else {
      // If the object has no parent, it's a top-level parent; add it if not already present
      // eslint-disable-next-line no-lonely-if
      if (!parentChildMap.has(obj.tid[0].value)) {
        parentChildMap.set(obj.tid[0].value, { parent: obj, children: [] });
      }
    }
  });

  // Convert the map into the desired array structure
  const array = Array.from(parentChildMap.values());

  // Sort parents by weight
  array.sort((a, b) => a.parent.weight[0].value - b.parent.weight[0].value);

  // Sort children by weight
  array.forEach((taxonomy) => {
    taxonomy.children.sort(
      (a: TaxonomyTheme, b: TaxonomyTheme) => a.weight[0].value - b.weight[0].value,
    );
  });

  return fromJS(array);
}
